export default __webpack_public_path__ + "static/media/brinidja002-color.e4974b47.svg";